import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PostoService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  // listar Postos
  list(params?: any): Observable<any> {
    return this.apiService.get(`/api/Postos`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    ).pipe(
      map(response => response)
    );
  }

  //listar por id
  show(id: string): Observable<any> {
    return this.apiService.get(
      `/api/Postos/${id}`,
    ).pipe(
      map(response => response)
    );
  }

  /**
* Cria uma nova Posto
* @param Posto
* @returns Observable<any>
*/
  public store(Posto: any): Observable<any> {
    return this.apiService.post(`/api/Postos`, Posto);
  }

  // atualizar Posto
  update(Posto: any, id: string): Observable<any> {
    return this.apiService.put(`/api/Postos/${id}`, Posto);
  }

  delete(id: string): Observable<any> {
    return this.apiService.delete(`/api/Postos/${id}`);
  }
}